<template>
<div class="form">
  <div class="loginForm">
    <h2>Komunikat dla akcjonariuszy</h2>
    <div class="error" v-if="message.length > 0">
      {{ message }}
    </div>
    <form method="post" action="./user.php" onsubmit="return false">
      <input placeholder="Użytkownik" name="username" type="email" required v-model="input.username" />
      <input placeholder="Hasło" type="password" autocomplete="false" name="password" required v-model="input.password" />

      <p class="center">
        <button v-on:click="login()">Zaloguj się</button>
        <small>Nowy użytkownik? <strong>Poproś o dostęp</strong></small>
      </p>
    </form>
  </div>
</div>
</template>

<script>
export default {
  name: "Login",
  props: {
    msg: String
  },
  data() {
    return {
      input: {
        username: "",
        password: ""
      },
      authenticated: false,
      message: ""
    };
  },
  methods: {
    login() {
      let th = this;
      var bodyFormData = new FormData();
      bodyFormData.set("userName", th.input.username);
      bodyFormData.set("pass", th.input.password);

      this.axios({
          method: "post",
          url: "./user.php",
          data: bodyFormData,
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(function (response) {
          //handle success
          if (response.data.response == "ok") {
            th.$emit("authenticated", true);
            th.$router.replace({
              name: "secure"
            });
          } else {
            th.message = "Złe dane logowania";
          }
        })
        .catch(function () {
          th.message = "Złe dane logowania";
        });
      return false;
    },
    logout() {
      this.$parent.authenticated = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
input,
label,
select,
button,
textarea {
  margin: 0;
  border: 0;
  padding: 0;
  display: inline-block;
  vertical-align: middle;
  white-space: normal;
  background: none;
  line-height: 1;
  font-size: 13px;
  font-family: Arial;
}

input:-internal-autofill-selected {
  background: none !important;
}

input:focus {
  outline: 0;
}

input,
textarea {
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
}

button,
input[type="reset"],
input[type="button"],
input[type="submit"],
input[type="checkbox"],
input[type="radio"],
select {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

input[type="date"],
input[type="datetime"],
input[type="datetime-local"],
input[type="email"],
input[type="month"],
input[type="number"],
input[type="password"],
input[type="range"],
input[type="search"],
input[type="tel"],
input[type="text"],
input[type="time"],
input[type="url"],
input[type="week"] {}

input[type="checkbox"],
input[type="radio"] {
  width: 13px;
  height: 13px;
}

input[type="file"] {}

input[type="search"] {
  -webkit-appearance: textfield;
  -webkit-box-sizing: content-box;
}

::-webkit-search-decoration {
  display: none;
}

button,
input[type="reset"],
input[type="button"],
input[type="submit"] {
  overflow: visible;
  width: auto;
}

::-webkit-file-upload-button {
  padding: 0;
  border: 0;
  background: none;
}

textarea {
  vertical-align: top;
  overflow: auto;
}

select {}

select[multiple] {
  vertical-align: top;
}

h2 {
  font-size: 1.4em;
  text-align: center;
}

input[type="email"],
input[type="password"] {
  border-bottom: 1px solid #c5c5c5;
  padding: 15px;
  display: block;
  width: 88%;
  font-size: 1.2em;
  font-style: italic;
}

$secondColor: #091935;

button,
.button {
  width: auto;
  max-width: 250px;
  cursor: pointer;
  display: block;
  background: $secondColor;
  border: 1px solid transparent;
  color: #fff;
  padding: 30px 15px;
  margin: 30px auto;
  font-size: 1.3em;
  font-weight: 600;
  text-decoration: none;
  text-align: center;
  font-family: "Poppins", sans-serif;
  transition: background 0.2s linear, color 0.5s linear;

  &:hover {
    background: #fff;
    border: 1px solid $secondColor;
    color: $secondColor;
  }
}

.error {
  background: #de8989;
  color: #fff;
  padding: 15px;
  margin-bottom: 15px;
  text-align: center;
}
</style>
